import { API } from "aws-amplify";
import * as APITypes from "~/API";
import { createYearlyReportSummary } from "~/graphql/mutations";
import { LoaderData } from "~/types";

const EMPTY_YEARLY_REPORT: APITypes.YearlyReportSummary = {
  __typename: "YearlyReportSummary",
  id: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  entityID: "",
  entityType: "",
  year: 0,
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const addYearlyReportSummary = async (
  payload: APITypes.CreateYearlyReportSummaryInput
): Promise<LoaderData<APITypes.YearlyReportSummary>> => {
  try {
    const response = (await API.graphql({
      query: createYearlyReportSummary,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.CreateYearlyReportSummaryMutation };
    return {
      success: true,
      data: response.data?.createYearlyReportSummary || EMPTY_YEARLY_REPORT,
    };
  } catch (error) {
    console.log("Error adding yearly report", error);
    return {
      success: false,
      data: EMPTY_YEARLY_REPORT,
      error,
    };
  }
};
